<div
  class="side-navigation-wrapper bg-primary h-screen fixed left-0 top-0 overflow-hidden z-50 transition-all duration-100"
  [ngClass]="vm().hovered ? 'w-60' : 'w-14'"
  (mouseenter)="onHover(true)"
  (mouseleave)="onHover(false)"
>

  <!-- LOGO -->
  <div class="py-2 pl-2 flex items-center">
    <img src="/assets/img/lightbulb-logo.png" class="h-10" />
    @if (vm().hovered) {
      <span class="text-white text-2xl pl-2">
        thelight<span class="text-accent">bulb</span>
      </span>
    }
  </div>

  <!-- TOP MENU -->
  <div class="px-2">
    @for (item of vm().menuTop; track item.id) {
      @if (item.show) {
        <div
          (click)="onMenuClick(item)"
          class="flex items-center my-1 pl-2 cursor-pointer rounded-r-full hover:bg-sidenav-hover"
          [class.bg-sidenav-hover]="isSelected(item.route)"
        >
          <img class="p-1" [src]="'/assets/img/' + item.icon" width="35" />
          @if (vm().hovered) {
            <span class="text-white pl-2">{{ item.label }}</span>
          }
        </div>
      }
    }
  </div>

  <!-- BOTTOM SECTION -->
  <div
    class="absolute bottom-0 px-2 pb-2"
    [ngClass]="vm().hovered ? 'w-60' : 'w-14'"
  >

    @for (item of vm().menuBottom; track item.id) {

      <!-- LOGOUT -->
      @if (item.id === 1 && item.show) {
        <div
          (click)="onMenuClick(item)"
          class="flex items-center my-1 pl-2 cursor-pointer hover:bg-sidenav-hover rounded-r-full"
        >
          <img class="p-1" src="/assets/img/logout.svg" width="35" />
          @if (vm().hovered) {
            <span class="text-white pl-2">{{ item.label }}</span>
          }
        </div>
      }

      <!-- DIVIDER -->
      @if (item.id === 2) {
        <hr class="opacity-20 my-2" />
      }

      <!-- PROFILE -->
      @if (item.id === 2) {
        <div
          class="flex items-center cursor-pointer pl-2"
          (click)="navigateToProfile()"
        >
          <div class="profile-picture text-primary">
            {{ vm().user.name[0] }}
          </div>

          @if (vm().hovered) {
            <div class="pl-3">
              <div class="text-accent">{{ vm().user.name }}</div>
              <div class="text-white text-xs">{{ vm().user.role }}</div>
            </div>
          }
        </div>
      }
    }

  </div>
</div>